<div class="p-6 space-y-4">
  @if (error) {
    <div class="p-3 bg-error-50 dark:bg-error-500/10 border border-error-200 dark:border-error-500/20 rounded-lg text-sm text-error-700 dark:text-error-400">{{ error }}</div>
  }
  <form [formGroup]="form" (ngSubmit)="guardar()" class="space-y-4">
    <div>
      <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
        Code <span class="text-error-500">*</span>
        @if (isEditing) { <span class="text-xs text-gray-400">(no editable)</span> }
      </label>
      <input type="text" formControlName="code" maxlength="80" placeholder="cf_severidad"
        class="w-full px-2.5 py-1.5 text-sm border rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 font-mono disabled:opacity-60 disabled:cursor-not-allowed"
        [class.border-error-500]="hasError('code')"
        [class.border-gray-300]="!hasError('code')" />
      <p class="text-xs text-gray-400 mt-1">snake_case, sólo `[a-z0-9_]`. Único por business.</p>
    </div>

    <div>
      <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
        Label visible <span class="text-error-500">*</span>
      </label>
      <input type="text" formControlName="label" maxlength="150"
        class="w-full px-2.5 py-1.5 text-sm border rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500"
        [class.border-error-500]="hasError('label')"
        [class.border-gray-300]="!hasError('label')" />
    </div>

    <div>
      <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
        Tipo <span class="text-error-500">*</span>
      </label>
      <select formControlName="fieldType"
        class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500">
        @for (t of fieldTypes; track t) {
          <option [value]="t">{{ t }}</option>
        }
      </select>
    </div>

    @if (needsOptions()) {
    <div>
      <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
        Opciones <span class="text-error-500">*</span>
      </label>
      <input type="text" formControlName="optionsCsv"
        placeholder="opcion1, opcion2, opcion3"
        class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500" />
      <p class="text-xs text-gray-400 mt-1">Separa con coma. Se guarda como array JSON.</p>
    </div>
    }

    <div class="grid grid-cols-2 gap-3">
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Orden</label>
        <input type="number" formControlName="sortOrder"
          class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500" />
      </div>
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Sección</label>
        <input type="text" formControlName="sectionName" placeholder="General, Avanzado..."
          class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500" />
      </div>
    </div>

    <div class="space-y-2">
      <label class="flex items-center gap-2 text-sm text-gray-700 dark:text-gray-300">
        <input type="checkbox" formControlName="isRequired" class="rounded border-gray-300 dark:border-gray-600" />
        Obligatorio al crear ticket
      </label>
      <label class="flex items-center gap-2 text-sm text-gray-700 dark:text-gray-300">
        <input type="checkbox" formControlName="isActive" class="rounded border-gray-300 dark:border-gray-600" />
        Activo
      </label>
    </div>

    <div class="flex justify-end gap-2 pt-3 border-t border-gray-200 dark:border-gray-700">
      <app-button variant="outline" type="button" (btnClick)="cancelar()">Cancelar</app-button>
      <app-button type="button" [disabled]="saving" (btnClick)="guardar()">
        @if (saving) { Guardando… } @else { {{ isEditing ? 'Actualizar' : 'Guardar' }} }
      </app-button>
    </div>
  </form>
</div>
